import { defaultUserStrategySettings } from "../../../../components";
import { IUserStrategySettings, useSettings } from "../../../../hooks";

const useUserStrategySettings = (userGuid: string) => {
  const {
    userStrategySettings: { [userGuid]: unsafeSettings },
    updateUserStrategySettings,
  } = useSettings();

  const safeSettings: IUserStrategySettings = {
    ...defaultUserStrategySettings,
    ...unsafeSettings,
  };

  return {
    settings: safeSettings,
    updateSettings: (updatedSettings: Partial<IUserStrategySettings>) => {
      updateUserStrategySettings(userGuid, updatedSettings);
    },
  };
};

export { useUserStrategySettings };
